import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Select, Input } from 'antd'

const Item = Form.Item
const Option = Select.Option

export default class CategoryAdd extends Component {

   // 基礎通用參數 ////////////////////////////////////////////// 

    static propTypes = {
        categorys: PropTypes.array.isRequired,
        nidParentCategory: PropTypes.string.isRequired,
        modalform: PropTypes.func.isRequired
    }

    fm = React.createRef();
    UNSAFE_componentWillMount() {
        // 將form對象透過modalform()傳遞給父組件
        this.props.modalform(this.fm)
    }

    ////////////////////////////////////////////////////////////   

    render() {
        const { categorys, nidParentCategory } = this.props
        return (
            <div>
                <Form ref={this.fm}>
                    <Item
                        label="分類項目"
                        name="nidParentCategory"
                        initialValue={nidParentCategory}
                    >
                        <Select>
                            <Option value="0">主分類項目</Option>
                            {
                                categorys.map(row => <Option value={row.nidCategory.toString()} key={row.nidCategory}>{row.categoryName}</Option>)
                            }
                        </Select>
                    </Item>
                    <Item
                        label="分類名稱"
                        name="categoryName"
                        initialValue=""
                        rules={[
                            { required: true, whitespace: true, message: '必須輸入名稱' },
                        ]}
                    >
                        <Input placeholder='請輸入分類名稱' />
                    </Item>
                </Form>
            </div>
        )
    }
}